module.exports = __webpack_public_path__ + "img/Presta3.0412ee1a.png";